window.$ = window.jQuery = require('jquery')

require('./web_function')

$(function () {

    $('.rd-share').on('click', function () {
        share({type: $(this).data('type')})
    })
})
